import client from "@irati/utils/services/apollo"
import PBService from "@irati/utils/services"

import dealMerchandiseRegionListQuery, {dealMerchandiseRegionListKey} from "./queries/dealMerchandiseRegionList"

class DealMerchandiseRegionListService extends PBService {
  async list(): Promise<string[]> {
    return client.query({query: dealMerchandiseRegionListQuery}).then(({data}) => {
      return data[dealMerchandiseRegionListKey]
    })
  }
}

const dealMerchandiseRegionListService = new DealMerchandiseRegionListService({errorHandlers: []})

export default dealMerchandiseRegionListService
